import {
  DefenseDoorAlwaysOpenCloseStatusTypes,
  DefenseEventTypes,
  IDefenseEventDoorAlwaysOpenCloseStatusProps,
} from '../../../../services/Defense/Events/types';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import React from 'react';
import {
  convertDoorAlwaysOpenCloseStatus,
  convertEventType,
} from '../../../../converters/Defense/ConverterDefense';
import DateFieldComponent from '../../../../components/DateFieldComponent';
import dayjs from 'dayjs';

interface IDefenseDoorAlwaysOpenCloseStatusContentProps {
  event: IDefenseEventDoorAlwaysOpenCloseStatusProps;
}

const DefenseDoorAlwaysOpenCloseStatusContent = ({
  event,
}: IDefenseDoorAlwaysOpenCloseStatusContentProps) => {
  const formatCreatedAt = (date: Date) => {
    return dayjs(date, 'YYYY/MM/DD HH:mm:ss');
  };

  return (
    <Grid2
      container
      direction={{ xs: 'column', lg: 'row' }}
      size={12}
      spacing={{ xs: 0, lg: 3 }}
      justifyContent={'center'}
      alignItems={{ xs: 'center', lg: 'normal' }}
    >
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Dispositivo"
          value={event?.device?.name ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo"
          value={
            convertEventType(event.type as DefenseEventTypes) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <DateFieldComponent
          label="Data/Hora"
          value={formatCreatedAt(event?.createdAt)}
          readOnly={true}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="ID do Canal"
          value={event?.channelId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Status de Porta"
          value={
            convertDoorAlwaysOpenCloseStatus(
              event.doorAlwaysOpenCloseStatus as DefenseDoorAlwaysOpenCloseStatusTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Descrição"
          value={event.description ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          multiline
        />
      </Grid2>
    </Grid2>
  );
};

export default DefenseDoorAlwaysOpenCloseStatusContent;
